<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-xs q-mb-sm" v-if="!insideModal">
            <div v-if="name === 'btPesquisar'" class="crud-title">
              <translate>SEARCH_RECORDS</translate>
            </div>
            <div v-else-if="name === 'btNovo'" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
          </q-card-section>
          <q-card-section class="no-padding">
            <div id="q-app">
              <q-scroll-area style="height: calc(78vh - 20px)">
                <contract-detail
                  v-if="elements"
                  :forms="elements"
                  @action-button="actionButtonModal"
                />
              </q-scroll-area>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>

    <div
      v-if="forms[0]"
      class="row full-width q-col-gutter-lg justify-center q-py-md"
    >
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
    <modal
      v-if="dadosModal.show"
      :show="dadosModal.show"
      :maximized="true"
      v-bind="dadosModal"
      @input="(show) => (dadosModal.show = show)"
      @action-button="actionButtonUpdate"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
import OpenComposition from './OpenComposition'
import ContractDetail from './ContractDetail'
const { page, pageDetail, modal } = JtCrud

@Component({
  mixins: [pageDetail],
  name: 'contractUpdate',
  components: { JtDynamicForm, OpenComposition, ContractDetail, pageDetail, modal },
  props: {
    name: String,
    label: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object,
    insideModal: {
      required: false,
      type: Boolean,
      default: false
    }
  }
})
class ContractUpdate extends Vue {
  dadosModal = { show: false }

  async actionButtonUpdate (button, params) {
    let data
    switch (button.name) {
      case 'btAlterar':
        data = await repository.update(button.action, { ...params })
        break
    }
    this.dadosModal.show = false
  }

  async actionButtonModal (button, params) {
    const data = await repository.resolve('contractItem.alterar', { id: params.contractItem })

    this.dadosModal = {
      show: true,
      label: this.$gettext('ITEMS_WASTE'),
      forms: data,
      detail: false,
      parent: this,
      params: params
    }
  }
}
export default ContractUpdate
</script>
<style lang="stylus" scoped>
.contract-data {
  #scroll-area {
    height: calc(50vh - 0px) !important;
  }
}

.contract-service {
  #scroll-area {
    height: calc(16vh - 0px) !important;
  }
}

.contract-items {
  #scroll-area {
    height: calc(40vh - 0px) !important;
  }
}

@media only screen and (max-height: 924px) {
  .contract-service {
    #scroll-area {
      height: calc(18vh - 0px) !important;
    }
  }

  .contract-items {
    #scroll-area {
      height: calc(43vh - 0px) !important;
    }
  }
}

@media only screen and (max-height: 880px) {
  .contract-data {
    #scroll-area {
      height: calc(55vh - 0px) !important;
    }
  }

  .contract-service {
    #scroll-area {
      height: calc(20vh - 0px) !important;
    }
  }

  .contract-items {
    #scroll-area {
      height: calc(46vh - 0px) !important;
    }
  }
}

@media only screen and (max-height: 798px) {
  .contract-data {
    #scroll-area {
      height: calc(60vh - 0px) !important;
    }
  }

  .contract-items {
    #scroll-area {
      height: calc(50vh - 0px) !important;
    }
  }
}

@media only screen and (max-height: 735px) {
  .contract-data {
    #scroll-area {
      height: calc(63vh - 0px) !important;
    }
  }

  .contract-service {
    #scroll-area {
      height: calc(22vh - 0px) !important;
    }
  }

  .contract-items {
    #scroll-area {
      height: calc(55vh - 0px) !important;
    }
  }
}
</style>
